import _asyncToGenerator from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useContext, useEffect, useRef } from 'react';
import Para from '../../atoms/Para';
import ListComponent from '../GoogleMapsHappyHealthyPets/ListComponent';
import { Context } from './MapStateProvider';
import { BUSINESS_TYPE } from './constants';
import { useMap } from '@vis.gl/react-google-maps';
function SideBar(_ref) {
  var toggleMap = _ref.toggleMap,
    setToggleMap = _ref.setToggleMap,
    filteredApiData = _ref.filteredApiData,
    selectedBusinessType = _ref.selectedBusinessType;
  var _useContext = useContext(Context),
    allCoorLocations = _useContext.allCoorLocations,
    closestLocationsFromCenter = _useContext.closestLocationsFromCenter,
    selectedLocation = _useContext.selectedLocation,
    handleSelectLocation = _useContext.handleSelectLocation,
    getMoreClosestLocations = _useContext.getMoreClosestLocations,
    isLoadingSideBar = _useContext.isLoadingSideBar,
    setSelectedLocationKey = _useContext.setSelectedLocationKey;
  var listContentRef = useRef();
  var map = useMap();
  useEffect(function () {
    var options = {
      threshold: [0, 1],
      rootMargin: '200px',
      root: listContentRef.current
    };
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        getMoreClosestLocations();
        observer.disconnect();
      }
    }, options);
    if (listContentRef.current) {
      var lastChild = listContentRef.current.children[listContentRef.current.children.length - 1];
      lastChild instanceof Element && observer.observe(lastChild);
    }
    return function () {
      observer.disconnect();
    };
  }, [closestLocationsFromCenter.length]);
  return __jsx("div", {
    className: "nva-maps-hhpets__side-bar side-bar ".concat(toggleMap ? '' : 'toggled is-toggled')
  }, __jsx("div", {
    className: "nva-maps-hhpets__display-locations-box display-locations-box"
  }, __jsx(Para, {
    className: "nva-maps-hhpets__display-locations display-locations"
  }, allCoorLocations === null || allCoorLocations === void 0 ? void 0 : allCoorLocations.length, " Locations")), __jsx("div", {
    className: "nva-maps-hhpets__list-content list-content",
    ref: listContentRef
  }, closestLocationsFromCenter === null || closestLocationsFromCenter === void 0 ? void 0 : closestLocationsFromCenter.map(function (item, index) {
    var _item$websiteUrl;
    return __jsx(ListComponent, {
      key: index,
      toggleMap: toggleMap,
      setTopOfSelectedCardToParent: function setTopOfSelectedCardToParent() {},
      itemIndex: index,
      name: item.name,
      item: item,
      selectedClinic: selectedLocation ? _objectSpread(_objectSpread({}, selectedLocation), {}, {
        index: 0
      }) : null,
      address: item.address,
      website: item === null || item === void 0 ? void 0 : (_item$websiteUrl = item.websiteUrl) === null || _item$websiteUrl === void 0 ? void 0 : _item$websiteUrl.url,
      listOnClick: /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_) {
          var site;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  site = allCoorLocations.find(function (site) {
                    var _item$meta;
                    return site.yId === (item === null || item === void 0 ? void 0 : (_item$meta = item.meta) === null || _item$meta === void 0 ? void 0 : _item$meta.id);
                  });
                  setSelectedLocationKey(site.yId);
                  map.setCenter({
                    lat: site.lat,
                    lng: site.lng
                  });
                  map.setZoom(15);
                  _context.next = 6;
                  return handleSelectLocation(site);
                case 6:
                  listContentRef.current.scrollTo({
                    top: 0
                  });
                case 7:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }(),
      coordinates: item.c_googleMyBusinessCID,
      reservationLink: item.reservationUrl && item.reservationUrl.url,
      phoneNumber: item.c_websitePhone || item.mainPhone,
      collapseButtonDisplay: true,
      businessType: item.c_businessType,
      setToggle: function setToggle() {
        setToggleMap(!toggleMap);
      }
    });
  }), isLoadingSideBar && __jsx("div", {
    className: "loading"
  }, __jsx("p", null, "Loading Locations...")), !isLoadingSideBar && (filteredApiData === null || filteredApiData === void 0 ? void 0 : filteredApiData.filter(function (each) {
    return selectedBusinessType === BUSINESS_TYPE.ALL ? each : each.c_businessType === selectedBusinessType;
  }).length) === 0 && __jsx("div", {
    className: "nva-maps-hhpets__no-locations no-locations-text"
  }, __jsx("p", null, "No locations are within this area. Please update your location or filters."))));
}
export default SideBar;